import { useState } from 'react';
import useModal from '../common/useModal';
import useOrderQuery from './useOrderQuery';
import GlobalAlert from '@/components/GlobalAlert';

const ORDER_DENY_REASONS: Array<string> = [
  '처방전 확인 불가 재접수 요청',
  '약 재고 부족',
  '주문량 폭주',
  '휴무일',
  '처방전 중복 사용',
  '영업 시간 종료',
  '약 배달 대상자 아님',
  '장기간 조제비 미결제',
  '기타'
];
const usePrescriptionDeny = (orderId: string) => {
  const { orderCancelByPharmMutation } = useOrderQuery();
  const [PrescriptionDenyModal, switchPrescriptionDenyModal] = useModal(false);
  const [cancelReason, setCancelReason] = useState<string>('');

  const onSubmitOrderCancelByPharmacy = () => {
    if (!cancelReason) {
      return GlobalAlert.show({
        title: '조제 거절',
        body: '사유를 최소 1가지 이상 체크해 주셔야 합니다.'
      });
    }
    return switchPrescriptionDenyModal();
  };

  const onSubmitPrescriptionDeny = () => {
    orderCancelByPharmMutation.mutate({
      orderId,
      cancelReason
    });
    switchPrescriptionDenyModal();
  };
  return {
    orderDenyReasons: ORDER_DENY_REASONS,
    cancelReason,
    setCancelReason,
    onSubmitOrderCancelByPharmacy,
    onSubmitPrescriptionDeny,
    PrescriptionDenyModal,
    onChangePrescriptionDenyModal: () =>
      switchPrescriptionDenyModal(!PrescriptionDenyModal)
  };
};

export default usePrescriptionDeny;
